import axios from "../api";
/**
 * Club-aware solutions for one challenge of a streamlined set (`body.sbcId`).
 */
export const solveStreamlinedSbc = async (setId, body = { earnedPoints: 0, completedEaPlayerIds: [] }) => {
    const res = await axios.post(`/streamlined-sbcs/${setId}/solutions`, body);
    return res.data;
};
//# sourceMappingURL=solveStreamlinedSbc.js.map